<template lang="pug">
.v-brands-slider.brands-slider(v-if="slider")
	.brands-slider__container.container
		.brands-slider__wrap
			.brands-slider__supertitle(v-if="slider.supertitle")
				v-svg-icon.brands-slider__supertitle-icon(:icon="slider.icon")
				.brands-slider__supertitle-text(v-html="slider.supertitle")
			.brands-slider__header
				.brands-slider__title(v-if="slider.title" v-html="slider.title")
				.brands-slider__navigation
					button.brands-slider__arrow.brands-slider__arrow--left(type="button" ref="prev" aria-label="Предыдущий слайд")
						.brands-slider__icon-wrap
							v-svg-icon.brands-slider__icon.brands-slider__icon--original(icon="arrow-left")
							v-svg-icon.brands-slider__icon.brands-slider__icon--copy(icon="arrow-left")
					button.brands-slider__arrow.brands-slider__arrow--right(type="button" ref="next" aria-label="Следующий слайд")
						.brands-slider__icon-wrap
							v-svg-icon.brands-slider__icon.brands-slider__icon--original(icon="arrow-right")
							v-svg-icon.brands-slider__icon.brands-slider__icon--copy(icon="arrow-right")
			.brands-slider__slider
				v-swiper-slider(:options="options"
						:navigation="navigation"
						:animated="false"
						swiper-class-name="brands-slider__swiper"
						@swiper="onSwiper")
					template(v-for="(item, index) in slider.items" :key="index")
						swiper-slide.brands-slider__slide
							.brands-slider__item
								img.brands-slider__image(:src="item.image" alt="")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import uniqueId from "../scripts/helpers/uniqueId.js";
import {SwiperSlide} from "swiper/vue";
import breakpoints from '../scripts/breakpoints.js';
import {Autoplay} from "swiper/modules";

export default {
	components: {
		SwiperSlide,
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			slider: null,
			uniqueId: uniqueId('swiper-'),
			options: {
				slidesPerView: 'auto',
				spaceBetween: 18,
				breakpoints: {
					[breakpoints['md-min']]: {
						spaceBetween: 32
					}
				},
				// loop: true,
				// observer: true,
				observeParents: true,
				loopedSlides: 9,
			},
			navigation: false,
			scrollbar: {
				draggable: true
			}
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				// document.body.classList.add('state--page-header-blackout');
			}
		},

		dataSet(data) {
			this.slider = data;
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
